export default __webpack_public_path__ + "static/media/car-icon.1d8336fc.svg";